import React from "react";
import styles from "./AnalyticsCard.module.scss";

/** State of the metric the tile shows, not a colour — see the stylesheet for what each one paints. */
export type AnalyticsCardType = "neutral" | "positive" | "negative" | "warning";

type Props = {
	children: React.ReactNode;
	type?: AnalyticsCardType;
};

/**
 * White box every analytics tile sits in. Holds the border, radius and padding
 * only — its stylesheet also carries the label / value rules the cards share,
 * and the colour the type resolves to, which the bar inside reads off it.
 */
const AnalyticsCard: React.FC<Props> = ({ children, type = "neutral" }) => (
	<div className={`${styles.card} ${styles[type]}`}>{children}</div>
);

export default AnalyticsCard;
